import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const AI_ANALYTICS_ACCOUNT_IDS = [1904];

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'bot_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'sla_reports',
    'account_bot_analytics',
    'account_call_analytics',
    'account_live_chat_metrics',
    ...(AI_ANALYTICS_ACCOUNT_IDS.includes(Number(accountId))
      ? ['account_ai_analytics']
      : []),
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: 'conversation_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: 'agent_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: 'team_reports',
    },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_SLA',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.SLA,
      toState: frontendURL(`accounts/${accountId}/reports/sla`),
      toStateName: 'sla_reports',
    },
    {
      icon: 'chat',
      label: 'BOT_ANALYTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/bot-analytics`),
      toStateName: 'account_bot_analytics',
    },
    {
      icon: 'chat',
      label: 'LIVE_CHAT_ANALYTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/live-chat-metrics`),
      toStateName: 'account_live_chat_metrics',
    },
    {
      icon: 'call',
      label: 'CALL_ANALYTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/call-analytics`),
      toStateName: 'account_call_analytics',
    },
    ...(AI_ANALYTICS_ACCOUNT_IDS.includes(Number(accountId))
      ? [
          {
            icon: 'bot',
            label: 'AI_ANALYTICS',
            hasSubMenu: false,
            toState: frontendURL(`accounts/${accountId}/reports/ai-analytics`),
            toStateName: 'account_ai_analytics',
          },
        ]
      : []),
  ],
});

export default reports;
